import React from 'react';

const GeneralEditContext = React.createContext({
    anyFieldChanged: undefined,
    countryCode: undefined,
    countryCodeError: undefined,
    firstName: undefined,
    language: undefined,
    lastName: undefined,
    legalNameVerified: undefined,
    onCancelClick: undefined,
    onCountryCodeChange: undefined,
    onFirstNameChange: undefined,
    onLastNameChange: undefined,
    onLegalNameVerifiedChange: undefined,
    onPhoneChange: undefined,
    onSaveClick: undefined,
    phone: undefined,
    phoneDisabled: undefined,
    phoneError: undefined,
    saveButtonDisabled: undefined,
});

GeneralEditContext.displayName = 'GeneralEditContext';

export default GeneralEditContext;
